import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { Button, Container, DivAcoes, Header, TextoHeader } from "./style";
import { formatarDinheiro } from "_utils/Money";
import { IListarPagamentoFornecedorAguardando } from "../../../../../interface/IListarPagamentoFornecedorAguardando";
import { FaCheck, FaEye, FaPen, FaPlus, FaTimes, FaUser } from "react-icons/fa";
import { ModalDetalhesLotePagamento } from "../ModalDetalhesLotePagamento";
import { IDetalheLotePagamento } from "../../../../../interface/IDetalheLotePagamento";
import { utils, writeFileXLSX } from "xlsx";
import { LoadingEstatisticaLote } from "../LoadingEstatisticaLote";
import { HttpResponse } from "_services/api/HttpResponse";
import { HttpError } from "_services/api/HttpError";
import { IData } from "_services/api/interface/HttpResponse";
import { useCallback, useEffect, useState } from "react";
import { IEstatisticasLotePagamento } from "../../../../../interface/IEstatisticasLotePagamento";
import { OpcoesExportar } from "../OpcoesExportar";
import { alertaErro } from "components/Alerta";
import { toast } from "react-toastify";
import { toastErro } from "components/Toast";
import { IRelatorioPagamentosDetalhado } from "../../../../../interface/IRelatorioPagamentosDetalhado";
import { converterDataBr, converterDataHoraBr } from "_utils/Data";
import usePermissoes from "hooks/usePermissoes";
import { StatusPagamentoAguardando } from "../StatusPagamentoAguardando";
import { ModalDetalhesLotePagamentoCorrigir } from "../ModalDetalhesLotePagamentoCorrigir";
import { ModalCertezaRemoverProcessos } from "../ModalCertezaRemoverProcessos";
import { ModalEditarProcesso } from "../ModalEditarProcesso";
import { ModalEditarProcessoNfReciboValores } from "../ModalEditarProcessoNfReciboValores";
import { ModalSucessoEditarProcessos } from "../ModalSucessoEditarProcessos";
import { ModalSucessoRemoverProcessos } from "../ModalSucessoRemoverProcessos";
import { IEditarProcesso } from "../../../../../interface/IEditarProcesso";
import { IAtualizarLote } from "../../../../../interface/IAtualizarLote";

interface IListarProps {
  dados: IListarPagamentoFornecedorAguardando[];
  handleLimitChange: (e: number) => void;
  handlePageChange: (e: number) => void;
  totalRows: number;
  setRowsSelected: (ids: number[]) => void;
  selectedRows: any[];
  selectedRowsCorrigir: any[];
  setSelectedRowsCorrigir: (ids: number[]) => void;
  loadingLista: boolean;
  linhasPorPagina: number;
  onClickAprovar: () => void;
  onClickReprovar: () => void;
  showModalDetalhesLotePagamento: boolean;
  dadosDetalhes: IDetalheLotePagamento[];
  handleCloseModalDetalhes: () => void;
  valorTotalLoteEscolhido: number | null;
  onClickVerDetalhes: (idLote: number) => void;
  buscarEstatisticasLotePagamento: (
    idLote: number,
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  buscarEstatisticasPagamento: (
    idProcessoFinanceiroAprovar: number,
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  onClickProcesso: (idProcesso: number) => void;
  relatorioDetalhado: (
    statusAprovacaoLote: "APROVADO" | "PENDENTE" | "REPROVADO",
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  relatorioResumido: (
    statusAprovacaoLote: "APROVADO" | "PENDENTE" | "REPROVADO",
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  numeroNfReciboEscolhido: string;
  onClickVerReciboNf: (idLote: number, numeroNfRecibo: string) => void;
  clearRows: boolean;
  setShowModalCriarLote: (show: boolean) => void;
  showModalDetalhesLotePagamentoCorrigir: boolean;
  handleCloseModalCorrigir: () => void;
  onClickVerDetalhesCorrigir: (idLote: number) => void;
  handleCloseModalCertezaRemoverProcessos: () => void;
  onConfirmModalCertezaRemoverProcessos: () => void;
  handleCloseModalEditarProcesso: () => void;
  onSubmitModalEditarProcesso: () => void;
  handleCloseModalEditarProcessoNfReciboValores: () => void;
  handleCloseModalSucessoEditarProcessos: () => void;
  handleCloseModalSucessoRemoverProcessos: () => void;
  onConfirmRemoverModalDetalhesLotePagamentoCorrigir: () => void;
  onConfirmSalvarModalDetalhesLotePagamentoCorrigir: () => void;
  onConfirmModalEditarProcessoNfReciboValores: () => void;
  showModalCertezaRemoverProcessos: boolean;
  showModalSucessoRemoverProcessos: boolean;
  showModalEditarProcesso: boolean;
  showModalEditarProcessoNfReciboValores: boolean;
  showModalSucessoEditarProcessos: boolean;
  abrirModalEditarProcesso: (idProcesso: number) => void;
  dadosEditarProcesso: IEditarProcesso | null;
  setDadosEditarProcesso: (dados: IEditarProcesso | null) => void;
  dadosAtualizarLote: IAtualizarLote | null;
  setDadosAtualizarLote: (dados: IAtualizarLote | null) => void;
  idLoteCorrigir: number | null;
  processosAlterar: any[];
  valorTotalLoteCorrigir: number | null;
  aba: string;
}

export function ListarAguardando({
  dados,
  handleLimitChange,
  handlePageChange,
  totalRows,
  setRowsSelected,
  selectedRows,
  selectedRowsCorrigir,
  setSelectedRowsCorrigir,
  loadingLista,
  linhasPorPagina,
  onClickAprovar,
  onClickReprovar,
  showModalDetalhesLotePagamento,
  dadosDetalhes,
  handleCloseModalDetalhes,
  valorTotalLoteEscolhido,
  onClickVerDetalhes,
  buscarEstatisticasLotePagamento,
  buscarEstatisticasPagamento,
  onClickProcesso,
  relatorioDetalhado,
  relatorioResumido,
  numeroNfReciboEscolhido,
  onClickVerReciboNf,
  clearRows,
  setShowModalCriarLote,
  showModalDetalhesLotePagamentoCorrigir,
  handleCloseModalCorrigir,
  onClickVerDetalhesCorrigir,
  handleCloseModalCertezaRemoverProcessos,
  onConfirmModalCertezaRemoverProcessos,
  handleCloseModalEditarProcesso,
  onSubmitModalEditarProcesso,
  handleCloseModalEditarProcessoNfReciboValores,
  handleCloseModalSucessoEditarProcessos,
  handleCloseModalSucessoRemoverProcessos,
  onConfirmRemoverModalDetalhesLotePagamentoCorrigir,
  onConfirmSalvarModalDetalhesLotePagamentoCorrigir,
  onConfirmModalEditarProcessoNfReciboValores,
  showModalCertezaRemoverProcessos,
  showModalSucessoRemoverProcessos,
  showModalEditarProcesso,
  showModalEditarProcessoNfReciboValores,
  showModalSucessoEditarProcessos,
  abrirModalEditarProcesso,
  dadosEditarProcesso,
  setDadosEditarProcesso,
  dadosAtualizarLote,
  setDadosAtualizarLote,
  idLoteCorrigir,
  processosAlterar,
  valorTotalLoteCorrigir,
  aba,
}: IListarProps) {
  const [estatisticasLotesPagamento, setEstatisticasLotesPagamento] = useState<
    IEstatisticasLotePagamento[]
  >([]);
  const [showModalExportar, setShowModalExportar] = useState<boolean>(false);
  const { listaPermissoes } = usePermissoes();
  const [showBtnAprovar, setShowBtnAprovar] = useState<boolean>(false);
  const [showBtnReprovar, setShowBtnReprovar] = useState<boolean>(false);
  const [showOptEditar, setShowOptEditar] = useState<boolean>(false);

  useEffect(() => {
    if (!listaPermissoes || !Array.isArray(listaPermissoes)) {
      return;
    }

    if (
      listaPermissoes.some(
        (item) =>
          item.nome_funcionalidade === "aprovar_lote_pagamento_fornecedor",
      )
    ) {
      setShowBtnAprovar(true);
    }

    if (
      listaPermissoes.some(
        (item) =>
          item.nome_funcionalidade === "reprovar_lote_pagamento_fornecedor",
      )
    ) {
      setShowBtnReprovar(true);
    }

    if (
      listaPermissoes.some(
        (item) =>
          item.nome_funcionalidade === "editar_lote_pagamento_fornecedor",
      )
    ) {
      setShowOptEditar(true);
    }
  }, [listaPermissoes]);

  useEffect(() => {
    if (aba !== "aguardando") return;

    const estatisticasIniciais = dados.map((item) => ({
      idLote: item.id,
      qtdProcessos: null,
      custoProcesso: null,
      servicoReceber: null,
      totalPagarFornecedor: null,
    }));
    setEstatisticasLotesPagamento(estatisticasIniciais);

    dados.forEach((item) => {
      carregarEstatisticasLote(item.id);
    });
  }, [dados]);

  const carregarEstatisticasLote = async (idLote: number) => {
    const { hasErro, data } = await buscarEstatisticasLotePagamento(idLote);

    setEstatisticasLotesPagamento((prev) =>
      prev.map((item) => {
        if (item.idLote != idLote) {
          return item;
        }

        return {
          idLote: idLote,
          qtdProcessos: hasErro ? 0 : data.qtdProcessos,
          totalPagarFornecedor: hasErro ? 0 : data.totalPagarFornecedor,
          custoProcesso: hasErro ? 0 : data.custoProcesso,
          servicoReceber: hasErro ? 0 : data.servicoReceber,
        };
      }),
    );
  };

  const columns: IColum<IListarPagamentoFornecedorAguardando>[] = [
    {
      name: "Nº Recibo / NF",
      selector: ({
        numeroNfRecibo,
        id,
      }: IListarPagamentoFornecedorAguardando) => (
        <div
          className="link-primary"
          style={{ cursor: "pointer" }}
          title="NF/Recibo"
          onClick={() => {
            onClickVerReciboNf(id, numeroNfRecibo);
          }}
        >
          {numeroNfRecibo}
        </div>
      ),
      width: "150px",
    },
    {
      name: "ID lote",
      selector: ({ id }: IListarPagamentoFornecedorAguardando) => id,
      width: "90px",
    },
    {
      name: "Fornecedor",
      selector: ({ nomeFornecedor }: IListarPagamentoFornecedorAguardando) =>
        nomeFornecedor ?? "-",
    },
    {
      name: <span>Usuário lançamento</span>,
      selector: ({
        responsavelLancamento,
      }: IListarPagamentoFornecedorAguardando) => responsavelLancamento ?? "-",
    },
    {
      name: "Processos",
      selector: ({ id }: IListarPagamentoFornecedorAguardando) => {
        return (
          <LoadingEstatisticaLote
            id={id}
            estatisticasLotesPagamento={estatisticasLotesPagamento}
            item={"qtdProcessos"}
          />
        );
      },
      width: "100px",
    },
    {
      name: <span>Total a pagar fornecedor</span>,
      selector: ({ valorNfRecibo }: IListarPagamentoFornecedorAguardando) =>
        valorNfRecibo ? formatarDinheiro(Number(valorNfRecibo)) : "-",
      width: "150px",
    },
    {
      name: <span>Custos do processo</span>,
      selector: ({ id }: IListarPagamentoFornecedorAguardando) => {
        return (
          <LoadingEstatisticaLote
            id={id}
            estatisticasLotesPagamento={estatisticasLotesPagamento}
            item={"custoProcesso"}
          />
        );
      },
      width: "150px",
    },
    {
      name: <span>Serviços a receber</span>,
      selector: ({ id }: IListarPagamentoFornecedorAguardando) => {
        return (
          <LoadingEstatisticaLote
            id={id}
            estatisticasLotesPagamento={estatisticasLotesPagamento}
            item={"servicoReceber"}
          />
        );
      },
      width: "150px",
    },
    {
      name: "Status",
      selector: ({ observacao }: IListarPagamentoFornecedorAguardando) => (
        <StatusPagamentoAguardando observacao={observacao} />
      ),
      width: "180px",
    },
    {
      name: <span>Observação</span>,
      selector: ({ observacao }: IListarPagamentoFornecedorAguardando) =>
        observacao ?? "-",
      width: "250px",
    },
    {
      name: "Ações",
      selector: ({ id }: IListarPagamentoFornecedorAguardando) => (
        <>
          <FaEye
            title="Visualizar lote"
            onClick={() => onClickVerDetalhes(id)}
            style={{ cursor: "pointer" }}
          />
          {showOptEditar && (
            <FaPen
              title="Editar lote"
              onClick={() => onClickVerDetalhesCorrigir(id)}
              style={{ cursor: "pointer", marginLeft: 16 }}
            />
          )}
        </>
      ),
      width: "90px",
    },
  ];

  const abrirModalExportar = () => {
    setShowModalExportar(!showModalExportar);
  };

  const onClickResumido = async () => {
    setShowModalExportar(false);

    const { data, hasErro } = await relatorioResumido("PENDENTE");

    if (hasErro) {
      toastErro(data?.message ?? "Não foi possível gerar o relatório");
      return;
    }

    const dadosPlanilha = data.itens.map(
      (item: IListarPagamentoFornecedorAguardando) => {
        const dadosProcesso = estatisticasLotesPagamento.find(
          (dado) => (dado.idLote = item.id),
        );

        return {
          "Nº Recibo / NF": item?.numeroNfRecibo,
          "ID lote": item?.id,
          Fornecedor: item?.nomeFornecedor,
          "Usuário lançamento": item?.responsavelLancamento ?? "-",
          Processos:
            dadosProcesso && dadosProcesso.qtdProcessos
              ? dadosProcesso.qtdProcessos
              : (item?.qtdProcessos ?? 0),
          "Total a pagar fornecedor": item?.valorNfRecibo
            ? formatarDinheiro(Number(item.valorNfRecibo))
            : "-",
          "Custos do processo":
            dadosProcesso && dadosProcesso.custoProcesso
              ? formatarDinheiro(Number(dadosProcesso.custoProcesso))
              : item?.custoProcesso
                ? formatarDinheiro(Number(item.custoProcesso))
                : "-",
          "Serviços a receber":
            dadosProcesso && dadosProcesso.servicoReceber
              ? formatarDinheiro(Number(dadosProcesso.servicoReceber))
              : item?.servicoReceber
                ? formatarDinheiro(Number(item.servicoReceber))
                : "-",
          Status: "Aguardando aprovação",
        };
      },
    );

    const planilha = utils.json_to_sheet(dadosPlanilha);
    planilha["!cols"] = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, planilha, "Detalhes");

    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, "0");
    const mes = String(hoje.getMonth() + 1).padStart(2, "0");
    const ano = hoje.getFullYear();
    const nomeArquivo = `PGTO_FORNECEDOR_${dia}-${mes}-${ano}.xlsx`;
    writeFileXLSX(workBook, nomeArquivo);
  };

  const onClickDetalhado = async () => {
    setShowModalExportar(false);

    const { hasErro, data } = await relatorioDetalhado("PENDENTE");

    if (hasErro) {
      toastErro(
        data?.message ?? "Não foi possível gerar o relatório detalhado",
      );
      return;
    }

    const dadosPlanilha = data.map((item: IRelatorioPagamentosDetalhado) => {
      return {
        "ID PROCESSO": item?.idProcesso ? item?.idProcesso : "-",
        PLACA: item?.placa ? item?.placa : "-",
        RENAVAM: item?.renavam ? item?.renavam : "-",
        SERVIÇO: item?.servico ? item?.servico : "-",
        EMPRESA: item?.nomeEmpresa ? item?.nomeEmpresa : "-",
        "CNPJ/CPF FORNECEDOR": item?.cpfCnpjFornecedor
          ? item?.cpfCnpjFornecedor
          : "-",
        "NOME FORNECEDOR": item?.nomeFornecedor ? item?.nomeFornecedor : "-",
        "VALOR DO PAGAMENTO": item?.valorPagamento
          ? Number(item.valorPagamento)
          : 0,
        "CHAVE PIX": item?.chavePix ? item?.chavePix : "-",
        "TITULAR DA CONTA PIX": item?.titularPix ? item?.titularPix : "-",
        BANCO: item?.banco ? item?.banco : "-",
        AGÊNCIA: item?.agencia ? item?.agencia : "-",
        "CONTA CORRENTE": item?.contaCorrente ? item?.contaCorrente : "-",
        "CNPJ/CPF TITULAR CONTA CORRENTE": item?.cpfCnpjTitularContaCorrente
          ? item?.cpfCnpjTitularContaCorrente
          : "-",
        "TITULAR CONTA CORRENTE": item?.titularContaCorrente
          ? item?.titularContaCorrente
          : "-",
        "STATUS PAGAMENTO": "Em validação",
        "DATA/HORA INCLUSÃO": item?.dataInclusao
          ? converterDataHoraBr(item?.dataInclusao)
          : "-",
        "DATA/HORA VALIDAÇÃO": item?.dataHoraValidacao
          ? converterDataHoraBr(item?.dataHoraValidacao)
          : "-",
        "DATA/HORA PAGAMENTO": item?.dataHoraPagamento
          ? converterDataHoraBr(item?.dataHoraPagamento)
          : "-",
        "RESPONSÁVEL VALIDAÇÃO": item?.responsavelValidacao
          ? item?.responsavelValidacao
          : "-",
        "RESPONSÁVEL PAGAMENTO": item?.responsavelPagamento
          ? item?.responsavelPagamento
          : "-",
      };
    });

    const planilha = utils.json_to_sheet(dadosPlanilha);

    const colunaValor = 7;
    const range = utils.decode_range(planilha["!ref"] ?? "A1");
    for (let row = range.s.r + 1; row <= range.e.r; row++) {
      const cellRef = utils.encode_cell({ r: row, c: colunaValor });
      if (planilha[cellRef]) {
        planilha[cellRef].z = '"R$ "#,##0.00';
      }
    }

    planilha["!cols"] = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, planilha, "Detalhes");

    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, "0");
    const mes = String(hoje.getMonth() + 1).padStart(2, "0");
    const ano = hoje.getFullYear();
    const nomeArquivo = `PGTO_FORNECEDOR_${dia}-${mes}-${ano}_DETALHADO.xlsx`;
    writeFileXLSX(workBook, nomeArquivo);
  };

  return (
    <Container>
      <Header>
        <TextoHeader>Lotes aguardando aprovação</TextoHeader>
        <DivAcoes>
          <Button outline variante="primary" onClick={abrirModalExportar}>
            <FaUser /> Exportar
          </Button>
          {showBtnReprovar && (
            <Button
              outline
              variante="primary"
              disabled={!selectedRows.length}
              onClick={onClickReprovar}
              style={{ width: "135px" }}
            >
              <FaTimes /> Reprovar lote
            </Button>
          )}
          <Button
            outline
            variante="primary"
            onClick={() => setShowModalCriarLote(true)}
            style={{ width: "135px" }}
          >
            <FaPlus /> Criar novo lote
          </Button>
          {showBtnAprovar && (
            <Button
              disabled={!selectedRows.length}
              onClick={onClickAprovar}
              style={{ width: "130px" }}
            >
              <FaCheck /> Aprovar lote
            </Button>
          )}
          <OpcoesExportar
            aberto={showModalExportar}
            onClickResumido={onClickResumido}
            onClickDetalhado={onClickDetalhado}
          />
        </DivAcoes>
      </Header>
      <hr />
      <Table
        keyField="id"
        totalRows={totalRows}
        pagination={true}
        columns={columns}
        data={dados}
        paginationRowsPerPageOptions={[30, 50, 100, 300]}
        loading={loadingLista}
        onChangeRowsPerPage={handleLimitChange}
        onChangePage={handlePageChange}
        noSubHeader
        possuiTooltip={false}
        selectableRows
        setRowsSelected={setRowsSelected}
        rowsPerPage={linhasPorPagina}
        headerFixo
        clearSelectedRows={clearRows}
      />
      <ModalDetalhesLotePagamento
        show={showModalDetalhesLotePagamento}
        dados={dadosDetalhes}
        handleClose={handleCloseModalDetalhes}
        buscarEstatisticasPagamento={buscarEstatisticasPagamento}
        numeroNfRecibo={numeroNfReciboEscolhido}
        valorTotalLoteEscolhido={valorTotalLoteEscolhido}
        onClickProcesso={onClickProcesso}
      />
      <ModalDetalhesLotePagamentoCorrigir
        show={showModalDetalhesLotePagamentoCorrigir}
        dados={dadosDetalhes}
        handleClose={handleCloseModalCorrigir}
        buscarEstatisticasPagamento={buscarEstatisticasPagamento}
        numeroNfRecibo={numeroNfReciboEscolhido}
        onClickProcesso={onClickProcesso}
        onConfirmRemover={onConfirmRemoverModalDetalhesLotePagamentoCorrigir}
        onConfirmSalvar={onConfirmSalvarModalDetalhesLotePagamentoCorrigir}
        selectedRows={selectedRowsCorrigir}
        setSelectedRows={setSelectedRowsCorrigir}
        abrirModalEditarProcesso={abrirModalEditarProcesso}
        processosAlterar={processosAlterar}
        valorTotalLoteCorrigir={valorTotalLoteCorrigir}
      />
      <ModalCertezaRemoverProcessos
        show={showModalCertezaRemoverProcessos}
        handleClose={handleCloseModalCertezaRemoverProcessos}
        onConfirm={onConfirmModalCertezaRemoverProcessos}
      />
      <ModalEditarProcesso
        show={showModalEditarProcesso}
        handleClose={handleCloseModalEditarProcesso}
        onSubmit={onSubmitModalEditarProcesso}
        idFornecedor={
          dados.find((lote) => lote.id === idLoteCorrigir)?.idFornecedor || 0
        }
        dadosEditarProcesso={dadosEditarProcesso}
        setDadosEditarProcesso={setDadosEditarProcesso}
      />
      <ModalEditarProcessoNfReciboValores
        show={showModalEditarProcessoNfReciboValores}
        handleClose={handleCloseModalEditarProcessoNfReciboValores}
        onConfirm={onConfirmModalEditarProcessoNfReciboValores}
        dadosAtualizarLote={dadosAtualizarLote}
        setDadosAtualizarLote={setDadosAtualizarLote}
        numeroNfRecibo={
          dados.find((lote) => lote.id === idLoteCorrigir)?.numeroNfRecibo ||
          "--"
        }
      />
      <ModalSucessoEditarProcessos
        show={showModalSucessoEditarProcessos}
        handleClose={handleCloseModalSucessoEditarProcessos}
        numeroNfRecibo={
          dados.find((lote) => lote.id === idLoteCorrigir)?.numeroNfRecibo ||
          "--"
        }
      />
      <ModalSucessoRemoverProcessos
        show={showModalSucessoRemoverProcessos}
        handleClose={handleCloseModalSucessoRemoverProcessos}
      />
    </Container>
  );
}
